import _array from './_array.js';
import _boolean from './_boolean.js';
import _nan from './_nan.js';
import _null from './_null.js';
import _number from './_number.js';
import _object from './_object.js';
import _string from './_string.js';
import _undefined from './_undefined.js';

const types = {
  [_array.type]: _array, 
  [_boolean.type]: _boolean, 
  [_nan.type]: _nan, 
  [_null.type]: _null, 
  [_number.type]: _number, 
  [_object.type]: _object, 
  [_string.type]: _string, 
  [_undefined.type]: _undefined
};

export const TYPES = Object.keys(types);

export default types;
